import { i18n } from "../../../boot/i18n";
import { store } from "../../../store";

export default {
  routes: [],

  dialogs: [
    {
      name: "expense-new",
      path: "/expenses/new/:po/:category",
      props: true,
      meta: {
        auth: () => store.getters.isEmployee(),
        icon: "expense",
        title: i18n.global.t("Submit Expense"),
      },
      component: () => import("../../../dialogs/employee/ExpenseEdit"),
    },
    {
      name: "expense-edit",
      path: "/expenses/:expenseID/edit",
      props: true,
      meta: {
        auth: () => store.getters.isEmployee(),
        icon: "expense",
        title: i18n.global.t("Submit Expense"),
      },
      component: () => import("../../../dialogs/employee/ExpenseEdit"),
    },
    {
      name: "expense-view",
      path: "/expenses/:expenseID/view",
      props: true,
      meta: {
        auth: () => store.getters.isEmployee(),
        icon: "expense",
        title: i18n.global.t("View Expense"),
      },
      component: () => import("../../../dialogs/employee/ExpenseView"),
    },
  ],
};
